export enum ActionTypes {
  LOAD_PAST_MAINTENANCES_REQUEST = 'LOAD_PAST_MAINTENANCES_REQUEST',
  LOAD_PAST_MAINTENANCES_SUCCEEDED = 'LOAD_PAST_MAINTENANCES_SUCCEEDED',
  LOAD_PAST_MAINTENANCES_FAILED = 'LOAD_PAST_MAINTENANCES_FAILED',
}
